import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AlertService } from '@core/services';
import { getResetToken } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class NewPasswordGuard {
  constructor(private router: Router, private alerts: AlertService) {}

  canActivate(): boolean | UrlTree {
    if (getResetToken()) {
      return true;
    }

    this.alerts.setAlertOnNavigate(APP_ROUTES.FORGOT_PASSWORD, {
      message: 'Your reset session expired. Please start again.',
      type: 'warning'
    });
    return this.router.createUrlTree([APP_ROUTES.FORGOT_PASSWORD]);
  }
}
